import { createSlice } from '@reduxjs/toolkit';
import { getContainers } from 'ducks/containers/operators';
import { Slices } from 'ducks/slices';
import { JobsContainersListAPI } from 'ducks/types/api-types';
import { WithUUID } from 'ducks/types/type-helpers';
import { normalizeArrayUUID } from 'ducks/utils';

export type ContainersState = WithUUID<JobsContainersListAPI>[];

const initialState: ContainersState = [];

const containersSlice = createSlice({
  name: Slices.CONTAINERS,
  initialState,
  reducers: {
    clearContainers: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContainers.pending, () => {
        return initialState;
      })
      .addCase(getContainers.fulfilled, (_, { payload }) => {
        return normalizeArrayUUID(payload);
      })
      .addCase(getContainers.rejected, () => {
        return initialState;
      });
  },
});

export const { clearContainers } = containersSlice.actions;

export default containersSlice.reducer;
